import { Flex } from "@chakra-ui/react";
import Layout from "@/components/layout/layout";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import LoginPage from "@/pages/login/LoginPage";
import SetPasswordPage from "@/pages/activation/SetPasswordPage";
import ForgotPasswordPage from "@/pages/activation/ForgotPasswordPage";
import TwoFactorRecoveryPage from "@/pages/twoFactorRecovery/TwoFactorRecoveryPage";
import HomePage from "@/pages/home/HomePage";
import RecruitmentDashboardPage from "@/pages/recruitment/RecruitmentDashboardPage";
import AllRecruitmentsPage from "@/pages/recruitment/AllRecruitmentsPage";
import SalesDashboardPage from "@/pages/sales/SalesDashboardPage";
import ModelsPage from "@/pages/models/ModelsPage";
import ModelDetailPage from "@/pages/models/ModelDetailPage";
import RecruitmentDetailPage from "@/pages/models/RecruitmentDetailPage";
import ConversationDetailPage from "@/pages/models/ConversationDetailPage";
import RecruitmentCandidatesPage from "@/pages/models/RecruitmentCandidatesPage";
import CandidateDetailPage from "@/pages/models/CandidateDetailPage";
import ScenarioDetailPage from "@/pages/models/ScenarioDetailPage";
import LeadsPage from "@/pages/models/LeadsPage";
import LeadDetailPage from "@/pages/models/LeadDetailPage";
import AccountSettingsPage from "@/pages/account/AccountSettingsPage";
import SubscriptionsPage from "@/pages/subscriptions/SubscriptionsPage";
import ChatPage from "@/pages/chat/ChatPage";
import PrivacyPolicyPage from "@/pages/privacy/PrivacyPolicyPage";

const AppContent = () => {
    return (
        <AuthProvider>
            <Flex gap={0} spacing={0} px={0} w="100%">
                <Routes>
                    <Route path="/c/:token" element={<ChatPage />} />
                    <Route path="/chat/:token" element={<ChatPage />} />
                    <Route path="/privacy/:recruitmentId" element={<PrivacyPolicyPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/activation/:token" element={<SetPasswordPage mode="activation" />} />
                    <Route path="/reset-password/:token" element={<SetPasswordPage mode="reset" />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/2fa-recovery" element={<TwoFactorRecoveryPage />} />
                    <Route element={<ProtectedRoute />}>
                        <Route element={<Layout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/recruitment" element={<RecruitmentDashboardPage />} />
                            <Route path="/recruitment/all" element={<AllRecruitmentsPage />} />
                            <Route path="/sales" element={<SalesDashboardPage />} />
                            <Route path="/models" element={<ModelsPage />} />
                            <Route path="/models/:id" element={<ModelDetailPage />} />
                            <Route path="/models/:id/scenarios/:scenarioId" element={<ScenarioDetailPage />} />
                            <Route path="/models/:id/recruitments/:recruitmentId" element={<RecruitmentDetailPage />} />
                            <Route path="/models/:id/recruitments/:recruitmentId/conversations/:conversationId" element={<ConversationDetailPage />} />
                            <Route path="/models/:id/recruitments/:recruitmentId/candidates" element={<RecruitmentCandidatesPage />} />
                            <Route path="/models/:id/recruitments/:recruitmentId/candidates/:candidateId" element={<CandidateDetailPage />} />
                            <Route path="/models/:id/campaigns/:campaignId/leads" element={<LeadsPage />} />
                            <Route path="/models/:id/campaigns/:campaignId/leads/:leadId" element={<LeadDetailPage />} />
                            <Route path="/models/:id/campaigns/:campaignId/leads/:leadId/conversations/:conversationId" element={<ConversationDetailPage />} />
                            <Route path="/account-settings" element={<AccountSettingsPage />} />
                            <Route path="/subscriptions" element={<SubscriptionsPage />} />
                        </Route>
                    </Route>
                </Routes>
            </Flex>
            <Toaster />
        </AuthProvider>
    );
};

export default AppContent;
